import React, { Component } from 'react';

class ItemAgendamentoAlunosTurma extends Component {
    constructor(props) {
        super(props);
        this.state = { alunos: [], alunosChecked: {} }



        this.handleInputChange = this.handleInputChange.bind(this);
    }
    async componentDidMount() {


        const { turma, event } = this.props
        let listaAlunos = await this.props.getAlunosDoAgendamento(event, turma.idEntityClass)
      ///  console.log('ff ',listaAlunos)
        this.setState({ alunos: listaAlunos || []})
    }


    async handleInputChange(event) {
        const target = event.target;
        await this.setState({ alunosChecked: { ...this.state.alunosChecked, [target.value]: target.checked } }, () => {
            // console.log(this.state.alunosChecked)
            this.props.onEditarAgendamentoAlunos && this.props.onEditarAgendamentoAlunos(this.state.alunosChecked)
        })

    }

    /**
     * Object including a HashMap where the key is the user's id and the value
     * { idUser:false|true, idUser:false|true }
     *
     *
     */

    render() {
        // const { turma, event } = this.props
        // console.log(' this.props',this.props)
        return (<>
            {this.state.alunos.map((aluno, index) => {
                return (<label key={`aluno_${this.props.event}_${index}`}>{aluno.txScreenName} </label>
                )
            })}
        </>);
    }
}

export default ItemAgendamentoAlunosTurma;